/** Request/response contracts for the single-user login endpoint. */
import { z } from 'zod';
export const loginRequestSchema = z.object({
    username: z.string().min(1).max(100),
    password: z.string().min(1).max(200),
});
export const loginResponseSchema = z.object({
    token: z.string(),
    username: z.string(),
    expiresAt: z.string(),
});
/** Settings → Account. The new password's rules are enforced here, for both the form and the API. */
export const changePasswordRequestSchema = z
    .object({
    currentPassword: z.string().min(1, 'Enter your current password').max(200),
    newPassword: z
        .string()
        .min(12, 'New password must be at least 12 characters')
        .max(200, 'New password must be at most 200 characters'),
})
    .refine((v) => v.newPassword !== v.currentPassword, {
    message: 'New password must be different from the current one',
    path: ['newPassword'],
});
//# sourceMappingURL=auth.js.map